// Autogenerated file
export const documentsTrackingStatusesEnum = {
    NotShipped: "NotShipped",
    InTransit: "InTransit",
    Delivered: "Delivered",
};
export const documentsTrackingStatuses = [
    { label: "Не отправлено", value: "NotShipped" },
    { label: "В пути", value: "InTransit" },
    { label: "Доставлено", value: "Delivered" },
];
